/* ------------------------------------------------------------------
   Mr Football - THE HAT-TRICK bundle builder.
   Markup and styling in snippets/mf-bundle.liquid.

   WHAT IT IS
   Pick a tier, then fill the slots with any kits from the catalogue,
   choosing a size for each, and add the whole basket in one call.

     1 kit            standard price
     3 kits           the cheapest is FREE
     6 kits           the two cheapest are FREE

   ================================================================
   THE OFFER BEHIND IT IS ONE DISCOUNT, NOT THREE
   ================================================================
   DiscountAutomaticNode/1854128652469 is "buy 2, get 1 free", scoped
   to the `hat-trick` collection, with NO uses-per-order limit. Because
   it is uncapped it simply repeats: 3 kits give 1 free, 6 kits give 2.

   SO "BUY 4 GET 2 FREE" IS THE SAME DEAL AS "BUY 2 GET 1 FREE".
   Both are a third off. The 6-kit tier is a bigger-basket nudge, not a
   deeper discount, and nothing here should imply otherwise - which is
   why the savings badge reads the same on both tiers instead of
   climbing. If that tier is ever meant to beat the other one, it needs
   its own discount object and the combination rules thinking through;
   editing this file alone would just lie to people.

   ================================================================
   WHICH ITEMS ARE FREE: THE CHEAPEST ONES, ALWAYS
   ================================================================
   Shopify's Buy-X-Get-Y always discounts the CHEAPEST qualifying
   items. The pool runs $30.00-$45.00, so a basket of retro ($39.99+)
   and men's ($34.99) kits does not give away whichever one the shopper
   thinks is free - it gives away the cheapest.

   markFree() therefore sorts the shopper's actual picks by price and
   flags the cheapest N. The badge moves as they change their mind.
   Showing the free badge on a fixed slot would have been simpler and
   would have been wrong, and the shopper would find out at checkout.

   ================================================================
   WHERE THE PICKABLE PRODUCTS COME FROM
   ================================================================
   /collections/<handle>/products.json, 50 at a time, lazily per tab,
   because the four categories hold ~1,250 products between them and
   nobody is waiting for that on page load. body_html comes back empty
   on this store, so the payload is small.

   !! inPool() MIRRORS THE SHOPIFY COLLECTION RULE. KEEP THEM EQUAL. !!
   `hat-trick` (Collection/666025820341) is a SMART collection:

       VARIANT_PRICE GREATER_THAN 29.99
       VARIANT_PRICE LESS_THAN   45.01
       TAG           NOT_EQUALS  no-hat-trick
       TITLE         NOT_CONTAINS x12 (the EXCLUDE list below)

   The categories are separate collections, and products.json cannot
   say which collections a product belongs to, so membership has to be
   recomputed here. If someone widens the price band in Shopify and not
   here, the picker quietly stops offering newly-eligible kits; if they
   narrow it and not here, the picker offers kits the discount will
   refuse and the shopper is short-changed at checkout. The second one
   is the one that costs money. CHANGE BOTH TOGETHER.

   ================================================================
   NAME AND NUMBER - FREE, PER KIT
   ================================================================
   Every slot grows a Name + Number bar the moment a size is chosen
   (not before - you print onto a size, so the size comes first, the
   same order the kit builder enforces). Both fields are optional;
   leave them blank for a plain shirt.

   It goes onto each line as the SAME line item property the rest of
   the shop uses, `Enter Name & Number (FREE)`, written as "NAME NUMBER"
   exactly like mf-kit-builder.js writes it - so the order screen and
   the printing team see one field, whichever way the shirt was bought.
   The key is read off the theme's own input when it exists, so
   renaming that field in the theme carries through here.

   Properties sent in our own JSON /cart/add.js DO reach the cart. The
   trap documented in mf-kit-builder.js is different: there, extra
   inputs added to the THEME'S form are dropped because the theme
   serialises its fields once at init. We never touch that form.

   Slot 1 is this product. If its bar is left empty but the shopper
   typed a name into "Build your kit" further up, that is used instead,
   so nothing typed anywhere on the page is lost.

   Typed values live on the pick object, not in the DOM. renderSlots()
   rebuilds the slot HTML on every size change, and anything kept only
   in an <input> would be wiped. Typing itself never re-renders, so the
   cursor never jumps.

   Kits with different names on the same size become separate cart
   lines, which is correct - they are different shirts. The hat-trick
   discount does not care about properties.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfBundle) { return; }
  window.__mfBundle = true;

  var TIERS = {
    '1': { slots: 1, free: 0 },
    '3': { slots: 3, free: 1 },
    '6': { slots: 6, free: 2 }
  };

  var CATS = [
    { key: 'mens',  label: "Men's kits",    handle: 'new-releases' },
    { key: 'kids',  label: "Kids' kits",    handle: 'kid' },
    { key: 'women', label: "Women's kits",  handle: 'women' },
    { key: 'retro', label: 'Retro kits',    handle: 'retro-kits' }
  ];

  /* Mirrors TITLE NOT_CONTAINS on the hat-trick collection. */
  var EXCLUDE = ['tracksuit', 'shorts', 'gloves', 'cleats', 'turf', 'shin',
                 'socks', 'mystery', 'scarf', 'windbreaker', 'bodysuit', 'matchball'];
  var MIN_CENTS = 2999;  /* GREATER_THAN 29.99 */
  var MAX_CENTS = 4501;  /* LESS_THAN    45.01 */
  var PAGE_SIZE = 50;

  /* Fallback only - the live key is read from the theme's own field. */
  var NN_KEY = 'Enter Name & Number (FREE)';

  var root, modal, self;
  var tier = '1';
  var picks = [];
  var activeSlot = 0;
  var activeCat = 'mens';
  var store = {};
  var hydrated = {};
  var searchTimer = null;
  var searchTerm = '';

  /* ---------------------------------------------------------------- */

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function inPool(p) {
    var t = String(p.title || '').toLowerCase();
    for (var i = 0; i < EXCLUDE.length; i++) {
      if (t.indexOf(EXCLUDE[i]) !== -1) { return false; }
    }
    var tags = p.tags || [];
    for (var j = 0; j < tags.length; j++) {
      if (String(tags[j]).toLowerCase() === 'no-hat-trick') { return false; }
    }
    var vs = p.variants || [];
    for (var k = 0; k < vs.length; k++) {
      if (!vs[k].available) { continue; }
      var c = Math.round(parseFloat(vs[k].price) * 100);
      if (c > MIN_CENTS && c < MAX_CENTS) { return true; }
    }
    return false;
  }

  /* products.json gives prices as "34.99"; /products/x.js gives 3499.
     Normalise to cents once, here, so nothing downstream has to care. */
  function normalise(p, centsAlready) {
    var img = '';
    if (p.images && p.images.length) { img = p.images[0].src || p.images[0]; }
    else if (p.featured_image) { img = p.featured_image; }
    return {
      handle: p.handle,
      title: p.title,
      img: img,
      variants: (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          price: centsAlready ? v.price : Math.round(parseFloat(v.price) * 100)
        };
      })
    };
  }

  /* ================= data ================= */

  function bucket(key) {
    if (!store[key]) { store[key] = { items: [], page: 1, done: false, loading: false }; }
    return store[key];
  }

  function loadPage(key) {
    var b = bucket(key);
    if (b.loading || b.done) { return Promise.resolve(b); }
    var cat = CATS.filter(function (c) { return c.key === key; })[0];
    if (!cat) { return Promise.resolve(b); }

    b.loading = true;
    renderList();

    return fetch('/collections/' + cat.handle + '/products.json?limit=' + PAGE_SIZE + '&page=' + b.page,
                 { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var got = (data && data.products) || [];
        if (got.length < PAGE_SIZE) { b.done = true; }
        b.page += 1;
        got.forEach(function (p) {
          if (inPool(p)) { b.items.push(normalise(p, false)); }
        });
        b.loading = false;
        renderList();
        /* A whole page can filter down to nothing - shorts and socks sit
           in these collections too. Keep going rather than showing an
           empty tab that actually has kits two pages down. */
        if (!b.done && b.items.length < 12) { return loadPage(key); }
        return b;
      })
      .catch(function () {
        b.loading = false;
        b.done = true;
        renderList();
        return b;
      });
  }

  function hydrate(handle) {
    if (hydrated[handle]) { return Promise.resolve(hydrated[handle]); }
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        hydrated[handle] = inPool({
          title: p.title,
          tags: p.tags,
          variants: (p.variants || []).map(function (v) {
            return { available: v.available, price: (v.price / 100).toFixed(2) };
          })
        }) ? normalise(p, true) : null;
        return hydrated[handle];
      })
      .catch(function () { hydrated[handle] = null; return null; });
  }

  function runSearch(term) {
    searchTerm = term;
    if (term.length < 2) { renderList(); return; }
    var q = encodeURIComponent(term);
    fetch('/search/suggest.json?q=' + q + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide',
          { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var hits = ((d.resources || {}).results || {}).products || [];
        return Promise.all(hits.map(function (h) { return hydrate(h.handle); }));
      })
      .then(function (list) {
        if (searchTerm !== term) { return; }   /* a later keystroke won */
        store.__search = {
          items: list.filter(Boolean),
          done: true, loading: false, page: 1
        };
        renderList();
      })
      .catch(function () {
        store.__search = { items: [], done: true, loading: false, page: 1 };
        renderList();
      });
  }

  /* ================= free-item maths ================= */

  function filled() {
    return picks.filter(function (p) { return p && p.variantId; });
  }

  function markFree() {
    picks.forEach(function (p) { if (p) { p.free = false; } });
    var n = TIERS[tier].free;
    if (!n) { return; }

    /* ONLY ONCE THE BUNDLE IS COMPLETE. Marking the cheapest of a
       half-built bundle makes the FREE badge hop from kit to kit as
       the shopper fills the slots, and it briefly promises that a kit
       is free which stops being free the moment a cheaper one lands
       next to it. Caught in testing on 2026-10-10: one $39.99 retro
       shirt in an empty 3-slot bundle was being shown as FREE. */
    var done = filled();
    if (done.length < slotsNeeded()) { return; }

    done = done.slice().sort(function (a, b) { return a.price - b.price; });
    done.slice(0, n).forEach(function (p) { p.free = true; });
  }

  function totals() {
    markFree();
    var gross = 0, save = 0;
    filled().forEach(function (p) {
      gross += p.price;
      if (p.free) { save += p.price; }
    });
    return { gross: gross, save: save, net: gross - save };
  }

  /* ================= render ================= */

  function slotsNeeded() { return TIERS[tier].slots; }

  function resize() {
    var want = slotsNeeded();
    while (picks.length < want) { picks.push(null); }
    picks.length = want;
    if (!picks[0]) { picks[0] = { handle: self.handle, title: self.title, img: self.img, variantId: null, size: '', price: 0, isSelf: true }; }
  }

  function renderTiers() {
    root.querySelectorAll('[data-mf-b-tier]').forEach(function (el) {
      var key = el.getAttribute('data-mf-b-tier');
      var mine = key === tier;
      el.setAttribute('aria-checked', mine ? 'true' : 'false');
      var panel = el.parentNode.querySelector('[data-mf-b-panel]');
      if (panel) { panel.hidden = !mine; }
      if (!mine) { resetTier(key); }
    });
  }

  /* EVERY TIER EXCEPT THE ACTIVE ONE GETS WIPED BACK TO EMPTY.

     renderSlots() only ever touches the tier on screen, so without this
     the other two keep whatever they were last rendered with - and that
     includes an ENABLED "Add 3 kits to cart" button sitting in a hidden
     panel while `picks` has since been resized for a different tier and
     is full of empty slots. Pressing it threw on a null pick and added
     nothing at all.

     A hidden panel is not clickable, so no shopper could reach it, but
     leaving a live button wired to stale state is how a real bug gets
     shipped later. Found on the storefront 2026-10-10. */
  function resetTier(key) {
    var box = root.querySelector('[data-mf-b-slots][data-for="' + key + '"]');
    if (box) { box.innerHTML = ''; }
    var sum = root.querySelector('[data-mf-b-total][data-for="' + key + '"]');
    if (sum) { sum.innerHTML = ''; }
    var cta = root.querySelector('[data-mf-b-add][data-for="' + key + '"]');
    if (cta) { cta.disabled = true; cta.textContent = 'Choose your kits'; }
  }

  /* The free name & number bar. Shown only once the slot has a size. */
  function nnBar(p, i) {
    return '<span class="mf-bun__nn">' +
      '<span class="mf-bun__nn-tag">Name &amp; number <b>Free</b></span>' +
      '<span class="mf-bun__nn-fields">' +
        '<input type="text" class="mf-bun__nn-name" data-mf-b-nn-name="' + i + '" maxlength="14" placeholder="Name" autocomplete="off" spellcheck="false" value="' + esc(p.nnName || '') + '" aria-label="Name to print on ' + esc(p.title) + '">' +
        '<input type="text" class="mf-bun__nn-num" data-mf-b-nn-num="' + i + '" maxlength="2" inputmode="numeric" placeholder="No." autocomplete="off" value="' + esc(p.nnNum || '') + '" aria-label="Number to print on ' + esc(p.title) + '">' +
      '</span>' +
    '</span>';
  }

  function printText(p) {
    if (!p) { return ''; }
    var name = String(p.nnName || '').trim().toUpperCase();
    var num = String(p.nnNum || '').trim();
    return (name + ' ' + num).replace(/\s+/g, ' ').trim();
  }

  function renderSlots() {
    var box = root.querySelector('[data-mf-b-slots][data-for="' + tier + '"]');
    if (!box) { return; }
    var t = totals();

    box.innerHTML = picks.map(function (p, i) {
      if (!p) {
        return '<div class="mf-bun__slot">' +
          '<span class="mf-bun__ph">+</span>' +
          '<span class="mf-bun__slot-main"><span class="mf-bun__slot-empty">Kit ' + (i + 1) + '</span></span>' +
          '<button type="button" class="mf-bun__choose" data-mf-b-open="' + i + '">Choose</button>' +
          '</div>';
      }

      var sizes = (lookupVariants(p) || []).map(function (v) {
        return '<option value="' + v.id + '"' + (String(v.id) === String(p.variantId) ? ' selected' : '') + '>' + esc(v.title) + '</option>';
      }).join('');

      var price = p.variantId
        ? (p.free
            ? '<span class="mf-bun__free"><s>' + money(p.price) + '</s><b>FREE</b></span>'
            : '<span class="mf-bun__price">' + money(p.price) + '</span>')
        : '';

      return '<div class="mf-bun__slot' + (p.free ? ' is-free' : '') + '">' +
        (p.img ? '<img class="mf-bun__thumb" src="' + esc(p.img) + '" alt="" loading="lazy" width="44" height="44">'
               : '<span class="mf-bun__ph">' + (i + 1) + '</span>') +
        '<span class="mf-bun__slot-main">' +
          '<span class="mf-bun__slot-title">' + esc(p.title) + (p.isSelf ? ' <em>this kit</em>' : '') + '</span>' +
          '<select class="mf-bun__size" data-mf-b-size="' + i + '" aria-label="Size for ' + esc(p.title) + '">' +
            '<option value="">Select size</option>' + sizes +
          '</select>' +
          (p.variantId ? nnBar(p, i) : '') +
        '</span>' +
        '<span class="mf-bun__slot-right">' + price +
          (p.isSelf ? '' : '<button type="button" class="mf-bun__swap" data-mf-b-open="' + i + '">Change</button>') +
        '</span>' +
      '</div>';
    }).join('');

    var out = root.querySelector('[data-mf-b-total][data-for="' + tier + '"]');
    if (out) {
      var missing = picks.filter(function (p) { return !p || !p.variantId; }).length;
      if (missing) {
        out.innerHTML = '<span class="mf-bun__todo">' + missing + ' more to choose</span>';
      } else {
        out.innerHTML = '<span class="mf-bun__pay">You pay ' + money(t.net) + '</span>' +
          (t.save ? '<span class="mf-bun__save">You save ' + money(t.save) + '</span>' : '');
      }
    }

    var cta = root.querySelector('[data-mf-b-add][data-for="' + tier + '"]');
    if (cta) {
      var ready = picks.every(function (p) { return p && p.variantId; });
      cta.disabled = !ready;
      cta.textContent = ready
        ? (slotsNeeded() === 1 ? 'Add to cart' : 'Add ' + slotsNeeded() + ' kits to cart')
        : 'Choose your kits';
    }
  }

  function lookupVariants(p) {
    if (p.isSelf) { return self.variants; }
    for (var k in store) {
      if (!store[k] || !store[k].items) { continue; }
      for (var i = 0; i < store[k].items.length; i++) {
        if (store[k].items[i].handle === p.handle) { return store[k].items[i].variants; }
      }
    }
    if (hydrated[p.handle]) { return hydrated[p.handle].variants; }
    return p.variants || [];
  }

  function renderTabs() {
    var wrap = modal.querySelector('[data-mf-b-tabs]');
    wrap.innerHTML = CATS.map(function (c) {
      return '<button type="button" class="mf-bun__tab" data-mf-b-cat="' + c.key + '" aria-selected="' +
        (c.key === activeCat && !searchTerm ? 'true' : 'false') + '">' + esc(c.label) + '</button>';
    }).join('');
  }

  function renderList() {
    if (!modal) { return; }
    var list = modal.querySelector('[data-mf-b-list]');
    var searching = searchTerm.length >= 2;
    var b = searching ? (store.__search || { items: [], loading: true, done: false }) : bucket(activeCat);

    var rows = b.items.map(function (p) {
      var opts = p.variants.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>';
      }).join('');
      var from = p.variants.length ? p.variants[0].price : 0;
      return '<div class="mf-bun__row" data-handle="' + esc(p.handle) + '">' +
        (p.img ? '<img class="mf-bun__row-img" src="' + esc(p.img) + '" alt="" loading="lazy" width="54" height="54">' : '<span class="mf-bun__ph">·</span>') +
        '<span class="mf-bun__row-main">' +
          '<span class="mf-bun__row-title">' + esc(p.title) + '</span>' +
          '<span class="mf-bun__row-price">' + money(from) + '</span>' +
          '<select class="mf-bun__row-size" aria-label="Size"><option value="">Select size</option>' + opts + '</select>' +
        '</span>' +
        '<button type="button" class="mf-bun__pick" disabled>Choose</button>' +
        '</div>';
    }).join('');

    if (!rows) {
      rows = '<p class="mf-bun__empty">' +
        (b.loading ? 'Loading kits&hellip;' : (searching ? 'Nothing in the offer matches that.' : 'No kits here.')) +
        '</p>';
    }

    var more = (!searching && !b.done && !b.loading)
      ? '<button type="button" class="mf-bun__more" data-mf-b-more>Load more</button>' : '';
    var spin = b.loading && b.items.length ? '<p class="mf-bun__empty">Loading&hellip;</p>' : '';

    list.innerHTML = rows + spin + more;
  }

  /* ================= cart ================= */

  /* The theme's own personalisation field, read as {key, value}. Its
     name is properties[Enter Name & Number (FREE)] and the key inside
     the brackets is what /cart/add.js wants, so it is unwrapped here
     rather than hard-coded - rename the field in the theme and this
     still works. */
  function nameNumber() {
    var c = document.querySelector('input[name^="properties[Enter Name"]');
    if (!c || !c.value || !c.value.trim()) { return null; }
    var m = /^properties\[(.+)\]$/.exec(c.name || '');
    if (!m) { return null; }
    return { key: m[1], value: c.value.trim() };
  }

  function nnKey() {
    var c = document.querySelector('input[name^="properties[Enter Name"]');
    var m = c && /^properties\[(.+)\]$/.exec(c.name || '');
    return m ? m[1] : NN_KEY;
  }

  function addBundle(btn) {
    /* Never trust the button's own state. It is set by renderSlots(),
       which runs for the active tier only, so a stale one is possible -
       and mapping over a half-filled `picks` throws on the first empty
       slot and silently adds nothing. Refuse instead. */
    if (!picks.length || !picks.every(function (p) { return p && p.variantId; })) {
      renderSlots();
      return;
    }

    var nn = nameNumber();
    var key = nnKey();
    var items = picks.map(function (p, i) {
      var item = { id: parseInt(p.variantId, 10), quantity: 1 };
      var text = printText(p);
      if (!text && i === 0 && nn) { text = nn.value; }
      if (text) {
        item.properties = {};
        item.properties[key] = text;
      }
      return item;
    });

    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { throw new Error('add failed'); }
      window.location.href = '/cart';
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = was;
      var err = root.querySelector('[data-mf-b-err]');
      if (err) { err.hidden = false; }
    });
  }

  /* ================= modal ================= */

  function openModal(slot) {
    activeSlot = slot;
    searchTerm = '';
    var input = modal.querySelector('[data-mf-b-search]');
    if (input) { input.value = ''; }
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    renderTabs();
    renderList();
    if (!bucket(activeCat).items.length) { loadPage(activeCat); }
    setTimeout(function () { try { input.focus(); } catch (e) {} }, 80);
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ================= wiring ================= */

  function onClick(ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }

    var tierEl = t.closest('[data-mf-b-tier]');
    if (tierEl && root.contains(tierEl)) {
      ev.preventDefault();
      tier = tierEl.getAttribute('data-mf-b-tier');
      resize();
      renderTiers();
      renderSlots();
      return;
    }

    var open = t.closest('[data-mf-b-open]');
    if (open) {
      ev.preventDefault();
      openModal(parseInt(open.getAttribute('data-mf-b-open'), 10));
      return;
    }

    if (t.closest('[data-mf-b-close]') || t === modal) {
      ev.preventDefault();
      closeModal();
      return;
    }

    /* SCOPED TO THE MODAL ON PURPOSE. The category tabs carry
       data-mf-b-cat, and so did the block's own context attribute once
       - which meant closest() walking up from the ADD TO CART button
       found the block itself, took the tab branch, and returned before
       ever adding anything. The button looked completely dead. The
       context attribute is data-mf-b-ctx now, and this is scoped as
       well, because one guard against that class of bug is not enough.
       Found on the storefront 2026-10-10. */
    var tab = t.closest('[data-mf-b-cat]');
    if (tab && modal.contains(tab)) {
      ev.preventDefault();
      activeCat = tab.getAttribute('data-mf-b-cat');
      searchTerm = '';
      var si = modal.querySelector('[data-mf-b-search]');
      if (si) { si.value = ''; }
      renderTabs();
      renderList();
      if (!bucket(activeCat).items.length) { loadPage(activeCat); }
      return;
    }

    if (t.closest('[data-mf-b-more]')) {
      ev.preventDefault();
      loadPage(activeCat);
      return;
    }

    var pick = t.closest('.mf-bun__pick');
    if (pick) {
      ev.preventDefault();
      var row = pick.closest('.mf-bun__row');
      var sel = row.querySelector('.mf-bun__row-size');
      if (!sel.value) { return; }
      var handle = row.getAttribute('data-handle');
      var opt = sel.options[sel.selectedIndex];
      picks[activeSlot] = {
        handle: handle,
        title: row.querySelector('.mf-bun__row-title').textContent,
        img: (row.querySelector('.mf-bun__row-img') || {}).src || '',
        variantId: sel.value,
        size: opt.textContent,
        price: parseInt(opt.getAttribute('data-price'), 10) || 0,
        isSelf: false
      };
      closeModal();
      renderSlots();
      return;
    }

    var add = t.closest('[data-mf-b-add]');
    if (add && root.contains(add) && !add.disabled) {
      ev.preventDefault();
      addBundle(add);
    }
  }

  function onChange(ev) {
    var t = ev.target;
    if (!t) { return; }

    if (t.classList && t.classList.contains('mf-bun__row-size')) {
      var btn = t.closest('.mf-bun__row').querySelector('.mf-bun__pick');
      btn.disabled = !t.value;
      return;
    }

    if (t.hasAttribute && t.hasAttribute('data-mf-b-size')) {
      var i = parseInt(t.getAttribute('data-mf-b-size'), 10);
      var p = picks[i];
      if (!p) { return; }
      var vs = lookupVariants(p);
      var v = vs.filter(function (x) { return String(x.id) === String(t.value); })[0];
      p.variantId = v ? v.id : null;
      p.size = v ? v.title : '';
      p.price = v ? v.price : 0;
      renderSlots();
    }
  }

  function onInput(ev) {
    var t = ev.target;
    if (!t || !t.hasAttribute) { return; }

    /* Name & number: store on the pick, never re-render while typing. */
    var isNum = t.hasAttribute('data-mf-b-nn-num');
    if (isNum || t.hasAttribute('data-mf-b-nn-name')) {
      var idx = parseInt(t.getAttribute(isNum ? 'data-mf-b-nn-num' : 'data-mf-b-nn-name'), 10);
      var pk = picks[idx];
      if (!pk) { return; }
      if (isNum) {
        var digits = t.value.replace(/\D/g, '').slice(0, 2);
        if (t.value !== digits) { t.value = digits; }
        pk.nnNum = digits;
      } else {
        pk.nnName = t.value;
      }
      return;
    }

    if (!t.hasAttribute('data-mf-b-search')) { return; }
    var val = t.value.trim();
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      if (val.length < 2) { searchTerm = ''; renderTabs(); renderList(); return; }
      store.__search = { items: [], loading: true, done: false, page: 1 };
      searchTerm = val;
      renderTabs();
      renderList();
      runSearch(val);
    }, 280);
  }

  function boot() {
    root = document.querySelector('[data-mf-bundle]');
    if (!root) { return; }
    modal = document.querySelector('[data-mf-b-modal]');
    if (!modal) { return; }

    try { self = JSON.parse(root.getAttribute('data-mf-b-self')); }
    catch (e) { return; }
    /* Liquid emits every variant with an `available` flag, because
       dropping the sold-out ones there means fiddling with trailing
       commas in a hand-built JSON string. Filter once, here. */
    self.variants = (self.variants || []).filter(function (v) { return v.available; });
    if (!self.variants.length) { return; }

    /* The modal is fixed-position and must not inherit a stacking
       context from the product column, so it lives on <body>. */
    if (modal.parentNode !== document.body) { document.body.appendChild(modal); }

    var ctx = root.getAttribute('data-mf-b-ctx');
    if (ctx && CATS.some(function (c) { return c.key === ctx; })) { activeCat = ctx; }

    resize();
    renderTiers();
    renderSlots();

    document.addEventListener('click', onClick, false);
    document.addEventListener('change', onChange, false);
    document.addEventListener('input', onInput, false);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) { closeModal(); }
      var t = e.target;
      if (e.key === 'Enter' && t && t.hasAttribute &&
          (t.hasAttribute('data-mf-b-nn-name') || t.hasAttribute('data-mf-b-nn-num'))) {
        e.preventDefault();
        t.blur();
      }
    }, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
